export default {
  name: 'transaction_informations_newsletter',
  component_path: 'modules/procedures/blocks/BlockInputCheckbox'
}